import { Button } from "@material-ui/core";
import { LiteBox } from "../lite/LiteBox";
import { DividerWithText } from "@lyfegen-platform/react-common";
import { useTranslation } from "react-i18next";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import useStyles from "./use-styles";

interface ILyfeViewMoreProps {
	expanded: boolean;
	onClick?: (expanded: boolean) => void;
}

export const LyfeViewMore = (props: ILyfeViewMoreProps) => {
	const { expanded, onClick } = props;
	const { t } = useTranslation();
	const { showMoreButton } = useStyles({});

	const handleClick = () => {
		onClick && onClick(!expanded);
	};

	const buttonText = t(expanded ? "view-less" : "view-all");

	return (
		<LiteBox width="100%">
			<DividerWithText text="" />
			<LiteBox py={1} display="flex" justifyContent="center">
				<Button
					className={showMoreButton}
					variant="text"
					color="primary"
					onClick={handleClick}
					endIcon={expanded ? <ExpandLess /> : <ExpandMore />}
				>
					{buttonText}
				</Button>
			</LiteBox>
		</LiteBox>
	);
};
